import type { Logger } from '@mimir/common/types/logger';
import type { ItemPollingOps } from './itemPollingOps';
import type { VideoApiActions } from '../util/apiActions';
import type { BasicFetch } from '@mimir/common/types/basicFetch';
import { ItemPollingService } from './itemPollingService';
import type { PeakInfo, PollingRequestDto } from '@mimir/common/dto/pollingDtos';
import type { Clock } from '@mimir/common/types/clock';
import { makePeaksFetcher } from './makePeaksFetcher';

export function makeItemPollingService(
  services: {
    logger: Logger,
    fetch: BasicFetch,
    decodeBase64: (base64: string) => Uint8Array,
    apiActions: Pick<VideoApiActions, 'getPeaks' | 'getPeaksDelta' | 'itemPolling'>,
    clock: Clock,
  },
): ItemPollingOps {

  const poll = async (request: PollingRequestDto) => {
    return await services.apiActions.itemPolling(request);
  };

  const peaksFetcherFactory = (itemId: string, peakInfo: PeakInfo) => {
    const fetchSingleTrackPeaksDto = async (audioTrackIndex: number) => {
      return await services.apiActions.getPeaks(itemId, audioTrackIndex);
    };

    const fetchPeaksDeltaDto = async (peakOffset: number) => {
      return await services.apiActions.getPeaksDelta(itemId, peakOffset);
    };

    return makePeaksFetcher({
      logger: services.logger,
      fetch: services.fetch,
      decodeBase64: services.decodeBase64,
      fetchSingleTrackPeaksDto,
      fetchPeaksDeltaDto,
    }, peakInfo);
  };


  return new ItemPollingService(
    services.logger,
    poll,
    peaksFetcherFactory,
    services.clock,
  );
}
